import { call, put, takeLatest } from 'redux-saga/effects'
import * as types from 'store/moderatorList/moderatorListTypes'
import API from 'store/moderatorList/moderatorListApis'

function* getModerators({payload : payload}) {
  try {
    console.log("payload in get moderators list ", payload)
    let response = yield call(API.getModeratorListRequest, payload)
    console.log("response ", response)
   if ( response.status === 200 ) {
      yield put({type:'FETCH_ALL_MODERATORS_SUCCEEDED', payload: response});
    } else if (response.status === 401) {
        yield put({type:'UNAUTHORIZED'})
    } else {
        yield put({type: 'FETCH_ALL_MODERATORS_FAILED'})
        yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again'}})
        yield put({type: 'HIDE_MESSAGE'})
    }
   } catch (err) {
       console.log("Fetch all moderators request failed: ",err);
       yield put({type:'FETCH_ALL_PROJEFETCH_ALL_MODERATORS_FAILEDTS_FAILED', err})
       yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again'}})
       yield put({type: 'HIDE_MESSAGE'})
     }
}

function* getAllModerators() {
  try {
    let response = yield call(API.getAllModerator)
   if ( response.status === 200 && response.data) {
      yield put({type:'FETCH_ALL_MODERATORS_WITHOUT_CLIENT_ID_SUCCEEDED', payload: response.data});
    } else if (response.status === 401) {
        yield put({type:'UNAUTHORIZED'})
    } else {
        yield put({type: 'FETCH_ALL_MODERATORS_WITHOUT_CLIENT_ID_FAILED'})
        yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again'}})
        yield put({type: 'HIDE_MESSAGE'})
    }
   } catch (err) {
       console.log("Fetch all moderators without client id in url request failed: ",err);
       yield put({type:'FETCH_ALL_MODERATORS_WITHOUT_CLIENT_ID_FAILED', err})
       yield put({type: 'SHOW_MESSAGE', payload: {message: 'There was an error processing your request, please try again'}})
       yield put({type: 'HIDE_MESSAGE'})
     }
}
export default function* moderatorListSaga () {
  yield takeLatest(types.FETCH_ALL_MODERATORS_REQUESTED, getModerators)
  yield takeLatest(types.FETCH_ALL_MODERATORS_WITHOUT_CLIENT_ID_REQUESTED, getAllModerators)
}
